import React from 'react';
import { Link } from 'react-router-dom';
import MockupSlider from './MockupSlider';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background text-gray-800 flex flex-col items-center justify-center p-6">
      {/* Hero Section */}
      <section className="text-center py-16 px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-primary mb-4 leading-tight">
          Unleash Your Creativity:
          <br />
          Design Custom T-Shirts with AI
        </h1>
        <p className="text-xl md:text-2xl text-secondary mb-8">
          Transform your ideas into unique apparel effortlessly. Generate stunning designs, remove backgrounds with a click, and bring your vision to life.
        </p>
        <Link
          to="/design"
          className="bg-accent hover:bg-pink-600 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
        >
          Start Designing Now
        </Link>
        {/* Placeholder for a captivating image/animation */}
        <div className="mt-12">
          <MockupSlider />
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-4 max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-primary mb-12">Features That Empower You</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="bg-card rounded-lg shadow-lg p-8 text-center transform hover:scale-105 transition duration-300 border border-gray-200">
            <div className="text-5xl text-accent mb-4">💡</div> {/* Icon placeholder */}
            <h3 className="text-2xl font-semibold mb-4">AI-Powered Design</h3>
            <p className="text-secondary">Generate unique and creative graphics from simple text prompts using advanced artificial intelligence.</p>
          </div>
          <div className="bg-card rounded-lg shadow-lg p-8 text-center transform hover:scale-105 transition duration-300 border border-gray-200">
            <div className="text-5xl text-accent mb-4">✂️</div> {/* Icon placeholder */}
            <h3 className="text-2xl font-semibold mb-4">Effortless Background Removal</h3>
            <p className="text-secondary">Achieve professional-looking designs with our one-click background removal tool for any image.</p>
          </div>
          <div className="bg-card rounded-lg shadow-lg p-8 text-center transform hover:scale-105 transition duration-300 border border-gray-200">
            <div className="text-5xl text-accent mb-4">👕</div> {/* Icon placeholder */}
            <h3 className="text-2xl font-semibold mb-4">Interactive Mockup Preview</h3>
            <p className="text-secondary">Visualize your designs on various t-shirt models and colors before you even place an order.</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 px-4 max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-primary mb-12">How It Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center">
            <div className="bg-primary text-white rounded-full w-16 h-16 flex items-center justify-center text-3xl font-bold mb-4 shadow-md">1</div>
            <h3 className="text-xl font-semibold mb-2">Generate or Upload</h3>
            <p className="text-secondary">Create a design with AI or upload your own image.</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-primary text-white rounded-full w-16 h-16 flex items-center justify-center text-3xl font-bold mb-4 shadow-md">2</div>
            <h3 className="text-xl font-semibold mb-2">Customize</h3>
            <p className="text-secondary">Adjust placement, size, and colors to perfect your design.</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-primary text-white rounded-full w-16 h-16 flex items-center justify-center text-3xl font-bold mb-4 shadow-md">3</div>
            <h3 className="text-xl font-semibold mb-2">Order</h3>
            <p className="text-secondary">Seamlessly place your custom t-shirt order with integrated print-on-demand.</p>
          </div>
        </div>
      </section>

      {/* Call to Action (Repeat) */}
      <section className="py-16 px-4 text-center">
        <h2 className="text-4xl font-bold text-primary mb-8">Ready to Create Your Masterpiece?</h2>
        <Link
          to="/design"
          className="bg-accent hover:bg-pink-600 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
        >
          Start Designing Now
        </Link>
      </section>

      {/* Footer */}
      <footer className="w-full bg-gray-800 text-white py-8 text-center">
        <p>&copy; {new Date().getFullYear()} AI T-Shirt Design. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;